module.exports = __webpack_public_path__ + "static/media/compass.25d2dd47.svg";